import { Route, Routes, useLocation } from "react-router-dom";

import PaymentOptions from "./components/PaymentOptions";

import MainNavigation from "./components/MainNavigation";
import CardPayment from "./components/Card/CardPayment";
import PayByTransfer from "./components/Transfer/PayByTransfer";
import PayWithPhone from "./components/Phone/PayWithPhone";
import CardSuccessful from "./components/Card/CardSuccessful";
import CardFailed from "./components/Card/CardFailed";
import CardTransaction from "./components/Card/CardTransaction";
import { useEffect } from "react";
import CardOtp from "./components/Card/CardOtp";
import TransferVerification from "./components/Transfer/TransferVerification";
import TransferSuccessful from "./components/Transfer/TransferSuccessful";
import TransferFailed from "./components/Transfer/TransferFailed";
import AuthorizePayment from "./components/Phone/AuthorizePayment";
import AuthorizationSuccessful from "./components/Phone/AuthorizationSuccessful";
import AuthorizationFailed from "./components/Phone/AuthorizationFailed";
import AuthorizationTimeout from "./components/Phone/AuthorizationTimeout";
import HowToPay from "./components/Phone/HowToPay";
import SupportedBanks from "./components/Phone/SupportedBanks";
import MiniNavigation from "./components/MiniNavigation";
import CardProvider from "./store/CardProvider";
import CardNavigation from "./components/CardNavigation";
import { Toaster } from "react-hot-toast";
import BankSelection from "./components/Transfer/BankSelection";
import PayAttitudeCardNav from "./components/PayattitudeCardNav";
import PayAttitudeOtp from "./components/PayAttitudeOtp";
import PaymentExpired from "./components/Card/PaymentExpired";
import RouteGuard from "./components/Card/RouteGuard";
import QrPayment from "./components/QR/QrPayment";
import Error from "./components/Error";
import { PaymentProvider } from "./store/PaymentContext";
import Subscription from "./components/Subscription/Subscription";




import MainNavigationSandbox from "./componentsSandbox/MainNavigation";
import CardPaymentSandbox from "./componentsSandbox/Card/CardPayment";
import PayByTransferSandbox from "./componentsSandbox/Transfer/PayByTransfer";
import PayWithPhoneSandbox from "./componentsSandbox/Phone/PayWithPhone";
import CardSuccessfulSandbox from "./componentsSandbox/Card/CardSuccessful";
import CardFailedSandbox from "./componentsSandbox/Card/CardFailed";
import CardTransactionSandbox from "./componentsSandbox/Card/CardTransaction";
import CardOtpSandbox from "./componentsSandbox/Card/CardOtp";
import TransferVerificationSandbox from "./componentsSandbox/Transfer/TransferVerification";
import TransferSuccessfulSandbox from "./componentsSandbox/Transfer/TransferSuccessful";
import TransferFailedSandbox from "./componentsSandbox/Transfer/TransferFailed";
import AuthorizePaymentSandbox from "./componentsSandbox/Phone/AuthorizePayment";
import AuthorizationSuccessfulSandbox from "./componentsSandbox/Phone/AuthorizationSuccessful";
import AuthorizationFailedSandbox from "./componentsSandbox/Phone/AuthorizationFailed";
import AuthorizationTimeoutSandbox from "./componentsSandbox/Phone/AuthorizationTimeout";
import HowToPaySandbox from "./componentsSandbox/Phone/HowToPay";
import SupportedBanksSandbox from "./componentsSandbox/Phone/SupportedBanks";
import MiniNavigationSandbox from "./componentsSandbox/MiniNavigation";
import CardNavigationSandbox from "./componentsSandbox/CardNavigation";
import BankSelectionSandbox from "./componentsSandbox/Transfer/BankSelection";
import PayAttitudeCardNavSandbox from "./componentsSandbox/PayattitudeCardNav";
import PayAttitudeOtpSandbox from "./componentsSandbox/PayAttitudeOtp";
import PaymentExpiredSandbox from "./componentsSandbox/Card/PaymentExpired";
import RouteGuardSandbox from "./componentsSandbox/Card/RouteGuard";
import QrPaymentSandbox from "./componentsSandbox/QR/QrPayment";
import ErrorSandbox from "./componentsSandbox/Error";
import SubscriptionSandbox from "./componentsSandbox/Subscription/Subscription";
import AggregatorScreen from "./components/Aggregator/AggregatorScreen";
import AggregatorSuccessful from "./components/Aggregator/AggregatorSuccessful";
import AggregatorFailed from "./components/Aggregator/AggregatorFailed";





function App() {
  return (
    <CardProvider>
      <PaymentProvider>
        <Toaster />
        <Routes>
          <Route path="/payment-expired" element={<PaymentExpired />} />
          <Route path="/error" element={<Error />} />
          <Route path="/subscription" element={<Subscription />} />
          <Route path="/subscribe" element={<Subscription />} />

          <Route
            path=":prefix?/:id/payment-confirmation/:confirmationId"
            element={<CardSuccessful />}
          />
          <Route path="/" element={<MainNavigation />}>
            <Route path=":id">
              <Route
                path=""
                element={
                  <RouteGuard protectedRoute={true}>
                    <CardPayment />
                  </RouteGuard>
                }
              />

              <Route path="card-failed/:id" element={<CardFailed />} />
            </Route>

            <Route path="transfer/:id">
              <Route path="" element={<PayByTransfer />} />
              <Route
                path="transfer-verification/:id"
                element={<TransferVerification />}
              />
              <Route
                path="transfer-successful/:id"
                element={<TransferSuccessful />}
              />
              <Route path="transfer-failed/:id" element={<TransferFailed />} />
            </Route>

            <Route path="phone/:id">
              <Route path="" element={<PayWithPhone />} />
              <Route
                path="phone-authorize/:id"
                element={<AuthorizePayment />}
              />
              <Route
                path="phone-successful/:id"
                element={<AuthorizationSuccessful />}
              />
              <Route
                path="phone-failed/:id"
                element={<AuthorizationFailed />}
              />
              <Route
                path="phone-timeout/:id"
                element={<AuthorizationTimeout />}
              />
              <Route path="how-to-pay/:id" element={<HowToPay />} />
              <Route
                path="phone-supported-banks/:id"
                element={<SupportedBanks />}
              />
            </Route>
            <Route path="qr/:id">
              <Route path="" element={<QrPayment />} />
            </Route>
          </Route>

          <Route path="payment" element={<CardNavigation />}>
            <Route path="card-transaction/:id" element={<CardTransaction />} />
            <Route path="card-otp/:id" element={<CardOtp />} />
          </Route>
          <Route path="payattitude" element={<PayAttitudeCardNav />}>
            <Route path="otp/:id" element={<PayAttitudeOtp />} />
          </Route>
        </Routes>


        <Routes>
          <Route path="/sandbox-pay/aggregator/:id" element={<AggregatorScreen />} />
          <Route path="/sandbox-pay/aggregator-successful/:id" element={<AggregatorSuccessful />} />
          <Route path="/sandbox-pay/aggregator-failed/:id" element={<AggregatorFailed />} />
          <Route path="/sandbox-pay/payment-expired" element={<PaymentExpiredSandbox />} />
          <Route path="/sandbox-pay/error" element={<ErrorSandbox />} />
          <Route path="/sandbox-pay/subscription" element={<SubscriptionSandbox />} />
          <Route path="/sandbox-pay/subscribe" element={<SubscriptionSandbox />} />

          <Route
            path=":prefix?/:id/payment-confirmation/:confirmationId/sandbox-pay"
            element={<CardSuccessfulSandbox />}
          />
          <Route path="/sandbox-pay/" element={<MainNavigationSandbox />}>
            <Route path="card/:id">
              <Route
                path=""
                element={
                  <RouteGuard protectedRoute={true}>
                    <CardPaymentSandbox />
                  </RouteGuard>
                }
              />

              <Route path="card-failed/:id" element={<CardFailedSandbox />} />
            </Route>

            <Route path="transfer/:id">
              <Route path="" element={<PayByTransferSandbox />} />
              <Route
                path="transfer-verification/:id"
                element={<TransferVerificationSandbox />}
              />
              <Route
                path="transfer-successful/:id"
                element={<TransferSuccessfulSandbox />}
              />
              <Route path="transfer-failed/:id" element={<TransferFailedSandbox />} />
            </Route>

            <Route path=":id">
              <Route path="" element={<PayWithPhoneSandbox />} />
              <Route
                path="phone-authorize/:id"
                element={<AuthorizePaymentSandbox />}
              />
              <Route
                path="phone-successful/:id"
                element={<AuthorizationSuccessfulSandbox />}
              />
              <Route
                path="phone-failed/:id"
                element={<AuthorizationFailedSandbox />}
              />
              <Route
                path="phone-timeout/:id"
                element={<AuthorizationTimeoutSandbox />}
              />
              <Route path="how-to-pay/:id" element={<HowToPaySandbox />} />
              <Route
                path="phone-supported-banks/:id"
                element={<SupportedBanksSandbox />}
              />
            </Route>
            <Route path="qr/:id">
              <Route path="" element={<QrPaymentSandbox />} />
            </Route>
          </Route>

          <Route path="/sandbox-pay/payment" element={<CardNavigationSandbox />}>
            <Route path="card-transaction/:id" element={<CardTransactionSandbox />} />
            <Route path="card-otp/:id" element={<CardOtpSandbox />} />
          </Route>
          <Route path="/sandbox-pay/payattitude" element={<PayAttitudeCardNavSandbox />}>
            <Route path="otp/:id" element={<PayAttitudeOtpSandbox />} />
          </Route>
        </Routes>
      </PaymentProvider>
    </CardProvider>
  );
}

export default App;
